import { Backdrop, SpeedDial, SpeedDialIcon, Icon, SpeedDialAction, Tooltip } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

import { useCallback } from "react";
import { theme } from "theme";

export type TFinancasGestaoReceberFloatingActionsProps = {
    open: boolean;
    onClick: () => void;
    onOpenFiltroAvancado: () => void
    onResetFiltro: () => void;
    onClickReceber: () => void;
    canVisualizar: boolean,
    canBaixar: boolean,
    canExcluir: boolean
}

const FinancasGestaoReceberFloatingActions = (props: TFinancasGestaoReceberFloatingActionsProps) => {
    const getIcon = useCallback(() => {
        return (
            <Tooltip title="ALT + ESPAÇO">
                <SpeedDialIcon
                    open={props.open}
                    icon={<Icon baseClassName='fa-solid fa-notes-medical' />}
                    openIcon={<CloseIcon />}
                />
            </Tooltip>
        )
    }, [props.open])

    return (
        <>
            <Backdrop
                onClick={props.onClick}
                open={props.open}
                sx={{ zIndex: 10 }}
            />
            <SpeedDial
                id="financas_gestao_receber_speed_dial"
                ariaLabel="Floating actions"
                // sx={props.mainButttonSx ? props.mainButttonSx : { marginBottom: '-3px', zIndex: 10 }}
                icon={getIcon()}
                onClick={props.onClick}
                open={props.open}
                FabProps={{
                    size: 'medium',
                    sx: {
                        backgroundColor: theme.palette.primary.main, '&:hover': { backgroundColor: theme.palette.primary.main, filter: 'grayscale(.2) brightness(.8) contrast(1.5)' },
                    }
                }}
            >
                <SpeedDialAction
                    id="receber_contas_receber"
                    key="receber_contas_receber"
                    sx={{
                        '& .MuiSpeedDialAction-staticTooltipLabel': {
                            whiteSpace: 'nowrap'
                        },
                        '.MuiSpeedDialAction-staticTooltipLabel': {
                            backgroundColor: theme.palette.background.default
                        },
                        cursor: !props.canBaixar ? 'not-allowed' : 'pointer',
                        opacity: !props.canBaixar ? 0.5 : 1,
                    }}
                    icon={<i className="fa-solid fa-hand-holding-dollar" style={{ fontSize: '20px', color: theme.palette.primary.main }} />}
                    tooltipTitle="Receber (Alt + R)"
                    tooltipOpen
                    onClick={!props.canBaixar ? undefined : props.onClickReceber}
                />

                <SpeedDialAction
                    id="limpar_filtro_avancado_contas_receber"
                    key="limpar_filtro_avancado_contas_receber"
                    sx={{
                        '& .MuiSpeedDialAction-staticTooltipLabel': {
                            whiteSpace: 'nowrap'
                        },
                        '.MuiSpeedDialAction-staticTooltipLabel': {
                            backgroundColor: theme.palette.background.default
                        },
                        cursor: "pointer"
                    }}
                    icon={<i className="fa-solid fa-filter-circle-xmark" style={{ fontSize: '20px', color: theme.palette.primary.main }} />}
                    tooltipTitle="Limpar Filtro (Alt + L)"
                    tooltipOpen
                    onClick={props.onResetFiltro}
                />

                <SpeedDialAction
                    id="filtro_avancado_contas_receber"
                    key="filtro_avancado_contas_receber"
                    sx={{
                        '& .MuiSpeedDialAction-staticTooltipLabel': {
                            whiteSpace: 'nowrap'
                        },
                        '.MuiSpeedDialAction-staticTooltipLabel': {
                            backgroundColor: theme.palette.background.default
                        },
                        cursor: "pointer"
                    }}
                    icon={<i className="fa-solid fa-filter" style={{ fontSize: '20px', color: theme.palette.primary.main }} />}
                    tooltipTitle="Filtro Avancado (Alt + F)"
                    tooltipOpen
                    onClick={props.onOpenFiltroAvancado}
                />

            </SpeedDial>
        </>
    )
}

export default FinancasGestaoReceberFloatingActions
